export default __webpack_public_path__ + "static/media/dreamfest (15).2b437f80.jpg";